import React from "react";
import { Input, Radio, Button, Row, Col } from "antd";
import { observer } from "mobx-react";

import { removeEmojis } from "../../utils/index";
let isImeOn = false; // IME 入力中フラグ
let isMessageTooLong = false; // this.message の文字数制限を超えているか

const RadioGroup = Radio.Group;
const radioStyle = {
  display: "block",
  height: "70px",
  lineHeight: "30px"
};

class CustomMessage extends React.Component {
  constructor() {
    super();
    this.state = {
      font: "beautiful",
      messages: ["", "", "", "", ""],
      saved: false
    };
  }

  handleClick = e => {
    const m = this.state.messages;
    this.props.book.changePersonalFont(this.state.font);
    for (let i = 0; i < m.length; i++)
      this.props.book.setPersonalMessage(i, m[i]);
    this.setState({ saved: true });
    this.props.order.nextStep();
  };
  handleRadioChange = e =>
    this.setState({ font: e.target.value, saved: false });
  handleTextChange = e => {
    let messages = this.state.messages;
    let message = e.target.value;
    if(!isImeOn) {
      message = removeEmojis(message); // 絵文字があれば除去
    }
    messages[e.target.id] = message;

    // 21文字を超えているか
    isMessageTooLong = messages.some(item => item.length > 21);
    // console.log({isMessageTooLong});
    this.setState({ messages, saved: false });
  };
  // 入力フォームの onChange イベントを IME ON のときに無視する
  // https://maku.blog/p/cv6fpx7/
  handleTextCompositionStart = () => {
    // console.log('handleTextCompositionStart');
    isImeOn = true; // IME 入力中フラグを ON
  }
  handleTextCompositionEnd = e => {
    // console.log('handleTextCompositionEnd');
    isImeOn = false; // IME 入力中フラグを OFF
    this.handleTextChange(e);
  }

  componentWillMount() {
    if (this.props.book) {
      const { personalFont, personalMessage } = this.props.book;
      let m = ["", "", "", "", "", "", "", ""];
      for (let i = 0; i < m.length; i++) m[i] = personalMessage[i];
      this.setState({ font: personalFont, messages: m });
    }
  }

  render() {
    return (
      <div className="custom-message">
        <div className="step pd-15">
          <div className="step-title">{"STEP 1"}</div>
          <div className="step-txt">
            {"プレゼントする相手へのメッセージを自由に記入してください。"}
            <br />
            {"※ 最大8行（1行の最大文字数は全角21文字）まで入力可能"}
            <br />
            {"※ １行毎に完結する文章のほうが美しい仕上がりになります"}
            <br />
            {"※ 絵文字や環境依存文字等はご利用いただけません"}
          </div>
        </div>

        {this.state.messages.map((v, i) => (
          <div className="message-line pd-r15 pd-l15" key={i} data-warning={v.length > 21}>
            <Row>
              <Col span={3}>
                <div className="txt-center">
                  <strong>{`${i + 1}行目`}</strong>
                  <br />
                  <span className="counter">(<span>{`${v.length}`}</span>/21)</span>
                </div>
              </Col>
              <Col span={21}>
                <Input
                  key={i}
                  id={i}
                  onChange={this.handleTextChange}
                  onCompositionStart={this.handleTextCompositionStart}
                  onCompositionEnd={this.handleTextCompositionEnd}
                  value={v}
                  size="large"
                />
              </Col>
            </Row>
          </div>
        ))}
        <div className="step pd-15 step-2">
          <div className="step-title">{"STEP 2"}</div>
          <div className="step-txt">
            {"メッセージの表示フォントを選んでください。"}
          </div>
          <br />
          <RadioGroup
            className="font-list"
            defaultValue="beautiful"
            onChange={this.handleRadioChange}
            value={this.state.font}
          >
            <Radio style={radioStyle} value="malecharacter" size="large">
              <img className="logo" src={require("../../imgs/font1.png")} />
            </Radio>
            <Radio style={radioStyle} value="shigoto" size="large">
              <img className="logo" src={require("../../imgs/font2.png")} />
            </Radio>
            <Radio style={radioStyle} value="banana" size="large">
              <img className="logo" src={require("../../imgs/font3.png")} />
            </Radio>
            <Radio style={radioStyle} value="hui" size="large">
              <img className="logo" src={require("../../imgs/font4.png")} />
            </Radio>
            <Radio style={radioStyle} value="beautiful" size="large">
              <img className="logo" src={require("../../imgs/font5.png")} />
            </Radio>
            <Radio style={radioStyle} value="genshin" size="large">
              <img className="logo" src={require("../../imgs/font6.png")} />
            </Radio>
          </RadioGroup>
          <br />
          <br />
          <div className="btn-wrap">
            <button
              disabled={this.state.messages.join("") === "" || isMessageTooLong}
              onClick={this.handleClick}
              className="btn product-btn"
            >
              {"保存して次へ"}
              <img
                src="https://cdn.shopify.com/s/files/1/0012/2568/7076/files/arrow-right-purple.png?13701503969354364487"
                className="btn-arrow"
              />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default observer(CustomMessage);



// WEBPACK FOOTER //
// ./src/components/steps/CustomMessage.js